export default __webpack_public_path__ + "static/media/achievements.91f23a5e.svg";